import CheckIcon from '@mui/icons-material/Check';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { PARTNER_SUBSCRIPTION_ADVANTAGE_KEYS } from '../../../lib/partnerSubscriptionAdvantages';
import type { PlanFeature } from '../planPresentation';

export function PopularPlanBadge(): ReactElement {
    const { t } = useTranslation();
    return (
        <Chip
            label={t('ONBOARDING.SUBSCRIPTION.POPULAR')}
            size="small"
            color="primary"
            sx={{ position: 'absolute', top: -11, right: 16, height: 22, borderRadius: 1 }}
        />
    );
}

export function PlanFeatureList({ features }: { features: PlanFeature[] }): ReactElement {
    const { t } = useTranslation();
    return (
        <Stack spacing={1} sx={{ width: '100%' }}>
            {features.map((feature) => (
                <Stack key={feature.key} direction="row" spacing={1} sx={{ alignItems: 'center' }}>
                    <CheckIcon sx={{ fontSize: 16, color: 'primary.main', flexShrink: 0 }} />
                    <Typography variant="body2" color="text.secondary">
                        {t(feature.key, feature.values)}
                    </Typography>
                </Stack>
            ))}
        </Stack>
    );
}

export function PlanBenefitsPanel(): ReactElement {
    const { t } = useTranslation();
    return (
        <Paper variant="outlined" sx={{ width: '100%', bgcolor: 'background.default', px: 2, py: 2.5 }}>
            <Stack spacing={2}>
                <Typography variant="subtitle1" color="text.secondary" sx={{ textAlign: 'center' }}>
                    {t('ONBOARDING.SUBSCRIPTION.BENEFITS_TITLE')}
                </Typography>
                <Box
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)' },
                        columnGap: 2,
                        rowGap: 2,
                    }}>
                    {PARTNER_SUBSCRIPTION_ADVANTAGE_KEYS.map((key) => (
                        <Stack key={key} direction="row" spacing={0.5} sx={{ alignItems: 'center' }}>
                            <CheckCircleOutlineIcon sx={{ fontSize: 20, color: 'secondary.main', flexShrink: 0 }} />
                            <Typography variant="body1" color="text.secondary">
                                {t(key)}
                            </Typography>
                        </Stack>
                    ))}
                </Box>
            </Stack>
        </Paper>
    );
}
